export default __webpack_public_path__ + "static/media/bitstop-app-rounded-showcase.32b74359.png";